export const translations = {
  en: {
    // Common
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    submit: "Submit",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    search: "Search",
    filter: "Filter",
    export: "Export",
    back: "Back",
    next: "Next",
    previous: "Previous",
    
    // Navigation
    home: "Home",
    dashboard: "Dashboard",
    transfers: "Transfers",
    beneficiaries: "Beneficiaries",
    statements: "Statements",
    settings: "Settings",
    support: "Support",
    logout: "Logout",
    
    // Auth
    login: "Login",
    signup: "Sign Up",
    forgotPassword: "Forgot Password?",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    firstName: "First Name",
    lastName: "Last Name",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    resetPassword: "Reset Password",
    newPassword: "New Password",
    
    // Landing
    heroTitle: "Your Gateway to Global Finance",
    heroSubtitle: "Seamless international transfers, multi-currency accounts, and modern banking solutions for the digital age.",
    getStarted: "Open Account",
    learnMore: "Learn More",
    whyChooseUs: "Why Choose Youse Capital",
    feature1Title: "Global Transfers",
    feature1Desc: "Send money to 180+ countries with competitive exchange rates and low fees.",
    feature2Title: "Multi-Currency Accounts",
    feature2Desc: "Hold, convert, and manage multiple currencies in one secure platform.",
    feature3Title: "Bank-Grade Security",
    feature3Desc: "Your funds are protected with enterprise-level security and encryption.",
    feature4Title: "24/7 Support",
    feature4Desc: "Our dedicated team is available around the clock to assist you.",
    
    // Dashboard
    welcomeBack: "Welcome back",
    totalBalance: "Total Balance",
    availableBalance: "Available Balance",
    heldBalance: "Held Balance",
    recentTransfers: "Recent Transfers",
    viewAll: "View All",
    kycStatus: "KYC Status",
    completeKyc: "Complete KYC",
    
    // KYC
    kycTitle: "Identity Verification",
    kycSubtitle: "Complete your identity verification to unlock all features",
    step1Profile: "Profile",
    step2Address: "Address",
    step3Identity: "Identity",
    step4Selfie: "Selfie",
    step5Source: "Source of Funds",
    step6Submit: "Submit",
    
    // KYC Status
    notStarted: "Not Started",
    submitted: "Submitted",
    autoApproved: "Auto Approved",
    autoRejected: "Auto Rejected",
    manualReview: "Manual Review",
    approved: "Approved",
    rejected: "Rejected",
    approvedWithException: "Approved (Exception)",
    needsMoreInfo: "Needs More Info",
    
    // Transfers
    newTransfer: "New Transfer",
    selectBeneficiary: "Select Beneficiary",
    amount: "Amount",
    currency: "Currency",
    targetCurrency: "Target Currency",
    transferType: "Transfer Type",
    domestic: "Domestic",
    international: "International",
    exchangeRate: "Exchange Rate",
    fee: "Fee",
    totalAmount: "Total Amount",
    youSend: "You Send",
    theyReceive: "They Receive",
    getQuote: "Get Quote",
    confirmTransfer: "Confirm Transfer",
    transferStatus: "Transfer Status",
    
    // Beneficiaries
    addBeneficiary: "Add Beneficiary",
    beneficiaryName: "Beneficiary Name",
    bankName: "Bank Name",
    accountNumber: "Account Number",
    routingNumber: "Routing Number",
    swiftCode: "SWIFT Code",
    country: "Country",
    
    // Statements
    statementTitle: "Account Statements",
    dateRange: "Date Range",
    startDate: "Start Date",
    endDate: "End Date",
    exportCsv: "Export CSV",
    exportPdf: "Export PDF",
    
    // Settings
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    accountSettings: "Account Settings",
    securitySettings: "Security Settings",
    
    // Support
    createTicket: "Create Ticket",
    subject: "Subject",
    message: "Message",
    category: "Category",
    ticketStatus: "Ticket Status",
    open: "Open",
    inProgress: "In Progress",
    resolved: "Resolved",
    closed: "Closed",
    
    // Admin
    adminDashboard: "Admin Dashboard",
    users: "Users",
    kycCases: "KYC Cases",
    limitsAndFees: "Limits & Fees",
    riskRules: "Risk Rules",
    auditLogs: "Audit Logs",
    supportTickets: "Support Tickets",
    overview: "Overview",
    totalUsers: "Total Users",
    pendingKyc: "Pending KYC",
    totalTransfers: "Total Transfers",
    pendingTransfers: "Pending Transfers",
    approve: "Approve",
    reject: "Reject",
    requestMoreInfo: "Request More Info",
    approveException: "Approve Exception",
    
    // Disclaimer
    disclaimer: "Youse Capital is a fully licensed digital bank. Your deposits are protected and insured.",
    
    // Errors
    invalidCredentials: "Invalid email or password",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    insufficientFunds: "Insufficient funds",
    kycRequired: "KYC approval required",
    transferFailed: "Transfer failed",
    
    // Success
    loginSuccess: "Login successful",
    registrationSuccess: "Account created successfully",
    transferConfirmed: "Transfer confirmed",
    beneficiaryAdded: "Beneficiary added",
    profileUpdated: "Profile updated",
    passwordChanged: "Password changed",
  },
  
  pt: {
    // Common
    loading: "Carregando...",
    save: "Salvar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    submit: "Enviar",
    delete: "Excluir",
    edit: "Editar",
    view: "Ver",
    search: "Buscar",
    filter: "Filtrar",
    export: "Exportar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    
    // Navigation
    home: "Início",
    dashboard: "Painel",
    transfers: "Transferências",
    beneficiaries: "Beneficiários",
    statements: "Extratos",
    settings: "Configurações",
    support: "Suporte",
    logout: "Sair",
    
    // Auth
    login: "Entrar",
    signup: "Cadastrar",
    forgotPassword: "Esqueceu a senha?",
    email: "E-mail",
    password: "Senha",
    confirmPassword: "Confirmar Senha",
    firstName: "Nome",
    lastName: "Sobrenome",
    createAccount: "Criar Conta",
    alreadyHaveAccount: "Já tem uma conta?",
    dontHaveAccount: "Não tem uma conta?",
    resetPassword: "Redefinir Senha",
    
    // Landing
    heroTitle: "Seu Portal para Finanças Globais",
    heroSubtitle: "Transferências internacionais sem complicações, contas multimoeda e soluções bancárias modernas para a era digital.",
    getStarted: "Abrir Conta",
    learnMore: "Saiba Mais",
    whyChooseUs: "Por que escolher a Youse Capital",
    feature1Title: "Transferências Globais",
    feature1Desc: "Envie dinheiro para mais de 180 países com taxas de câmbio competitivas e baixas tarifas.",
    feature2Title: "Contas Multimoeda",
    feature2Desc: "Mantenha, converta e gerencie múltiplas moedas em uma plataforma segura.",
    feature3Title: "Segurança Bancária",
    feature3Desc: "Seus fundos são protegidos com segurança e criptografia de nível empresarial.",
    feature4Title: "Suporte 24/7",
    feature4Desc: "Nossa equipe dedicada está disponível 24 horas para ajudá-lo.",
    
    // Dashboard
    welcomeBack: "Bem-vindo de volta",
    totalBalance: "Saldo Total",
    availableBalance: "Saldo Disponível",
    heldBalance: "Saldo Retido",
    recentTransfers: "Transferências Recentes",
    viewAll: "Ver Tudo",
    kycStatus: "Status KYC",
    completeKyc: "Completar KYC",
    
    // KYC
    kycTitle: "Verificação de Identidade",
    kycSubtitle: "Complete sua verificação de identidade para desbloquear todos os recursos",
    step1Profile: "Perfil",
    step2Address: "Endereço",
    step3Identity: "Identidade",
    step4Selfie: "Selfie",
    step5Source: "Origem dos Fundos",
    step6Submit: "Enviar",
    
    // KYC Status
    notStarted: "Não Iniciado",
    submitted: "Enviado",
    autoApproved: "Aprovado Automaticamente",
    autoRejected: "Rejeitado Automaticamente",
    manualReview: "Revisão Manual",
    approved: "Aprovado",
    rejected: "Rejeitado",
    approvedWithException: "Aprovado (Exceção)",
    needsMoreInfo: "Precisa de Mais Informações",
    
    // Transfers
    newTransfer: "Nova Transferência",
    selectBeneficiary: "Selecionar Beneficiário",
    amount: "Valor",
    currency: "Moeda",
    targetCurrency: "Moeda de Destino",
    transferType: "Tipo de Transferência",
    domestic: "Nacional",
    international: "Internacional",
    exchangeRate: "Taxa de Câmbio",
    fee: "Taxa",
    totalAmount: "Valor Total",
    youSend: "Você Envia",
    theyReceive: "Eles Recebem",
    getQuote: "Obter Cotação",
    confirmTransfer: "Confirmar Transferência",
    transferStatus: "Status da Transferência",
    
    // Beneficiaries
    addBeneficiary: "Adicionar Beneficiário",
    beneficiaryName: "Nome do Beneficiário",
    bankName: "Nome do Banco",
    accountNumber: "Número da Conta",
    routingNumber: "Número de Roteamento",
    swiftCode: "Código SWIFT",
    country: "País",
    
    // Statements
    statementTitle: "Extratos da Conta",
    dateRange: "Período",
    startDate: "Data Inicial",
    endDate: "Data Final",
    exportCsv: "Exportar CSV",
    exportPdf: "Exportar PDF",
    
    // Settings
    changePassword: "Alterar Senha",
    currentPassword: "Senha Atual",
    newPassword: "Nova Senha",
    accountSettings: "Configurações da Conta",
    securitySettings: "Configurações de Segurança",
    
    // Support
    createTicket: "Criar Chamado",
    subject: "Assunto",
    message: "Mensagem",
    category: "Categoria",
    ticketStatus: "Status do Chamado",
    open: "Aberto",
    inProgress: "Em Andamento",
    resolved: "Resolvido",
    closed: "Fechado",
    
    // Admin
    adminDashboard: "Painel Administrativo",
    users: "Usuários",
    kycCases: "Casos KYC",
    limitsAndFees: "Limites e Taxas",
    riskRules: "Regras de Risco",
    auditLogs: "Logs de Auditoria",
    supportTickets: "Chamados de Suporte",
    overview: "Visão Geral",
    totalUsers: "Total de Usuários",
    pendingKyc: "KYC Pendente",
    totalTransfers: "Total de Transferências",
    pendingTransfers: "Transferências Pendentes",
    approve: "Aprovar",
    reject: "Rejeitar",
    requestMoreInfo: "Solicitar Mais Informações",
    approveException: "Aprovar Exceção",
    
    // Disclaimer
    disclaimer: "Youse Capital é um banco digital totalmente licenciado. Seus depósitos são protegidos e segurados.",
    
    // Errors
    invalidCredentials: "E-mail ou senha inválidos",
    emailRequired: "E-mail é obrigatório",
    passwordRequired: "Senha é obrigatória",
    insufficientFunds: "Saldo insuficiente",
    kycRequired: "Aprovação KYC necessária",
    transferFailed: "Transferência falhou",
    
    // Success
    loginSuccess: "Login realizado com sucesso",
    registrationSuccess: "Conta criada com sucesso",
    transferConfirmed: "Transferência confirmada",
    beneficiaryAdded: "Beneficiário adicionado",
    profileUpdated: "Perfil atualizado",
    passwordChanged: "Senha alterada",
  },
  
  es: {
    // Common
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    submit: "Enviar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    search: "Buscar",
    filter: "Filtrar",
    export: "Exportar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    
    // Navigation
    home: "Inicio",
    dashboard: "Panel",
    transfers: "Transferencias",
    beneficiaries: "Beneficiarios",
    statements: "Estados de Cuenta",
    settings: "Configuración",
    support: "Soporte",
    logout: "Cerrar Sesión",
    
    // Auth
    login: "Iniciar Sesión",
    signup: "Registrarse",
    forgotPassword: "¿Olvidó su contraseña?",
    email: "Correo Electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    firstName: "Nombre",
    lastName: "Apellido",
    createAccount: "Crear Cuenta",
    alreadyHaveAccount: "¿Ya tiene una cuenta?",
    dontHaveAccount: "¿No tiene una cuenta?",
    resetPassword: "Restablecer Contraseña",
    
    // Landing
    heroTitle: "Tu Puerta a las Finanzas Globales",
    heroSubtitle: "Transferencias internacionales sin complicaciones, cuentas multidivisa y soluciones bancarias modernas para la era digital.",
    getStarted: "Abrir Cuenta",
    learnMore: "Saber Más",
    whyChooseUs: "¿Por qué elegir Youse Capital?",
    feature1Title: "Transferencias Globales",
    feature1Desc: "Envíe dinero a más de 180 países con tasas de cambio competitivas y bajas tarifas.",
    feature2Title: "Cuentas Multidivisa",
    feature2Desc: "Mantenga, convierta y administre múltiples monedas en una plataforma segura.",
    feature3Title: "Seguridad Bancaria",
    feature3Desc: "Sus fondos están protegidos con seguridad y cifrado de nivel empresarial.",
    feature4Title: "Soporte 24/7",
    feature4Desc: "Nuestro equipo dedicado está disponible las 24 horas para ayudarle.",
    
    // Dashboard
    welcomeBack: "Bienvenido de vuelta",
    totalBalance: "Saldo Total",
    availableBalance: "Saldo Disponible",
    heldBalance: "Saldo Retenido",
    recentTransfers: "Transferencias Recientes",
    viewAll: "Ver Todo",
    kycStatus: "Estado KYC",
    completeKyc: "Completar KYC",
    
    // KYC
    kycTitle: "Verificación de Identidad",
    kycSubtitle: "Complete su verificación de identidad para desbloquear todas las funciones",
    step1Profile: "Perfil",
    step2Address: "Dirección",
    step3Identity: "Identidad",
    step4Selfie: "Selfie",
    step5Source: "Origen de Fondos",
    step6Submit: "Enviar",
    
    // KYC Status
    notStarted: "No Iniciado",
    submitted: "Enviado",
    autoApproved: "Aprobado Automáticamente",
    autoRejected: "Rechazado Automáticamente",
    manualReview: "Revisión Manual",
    approved: "Aprobado",
    rejected: "Rechazado",
    approvedWithException: "Aprobado (Excepción)",
    needsMoreInfo: "Necesita Más Información",
    
    // Transfers
    newTransfer: "Nueva Transferencia",
    selectBeneficiary: "Seleccionar Beneficiario",
    amount: "Monto",
    currency: "Moneda",
    targetCurrency: "Moneda de Destino",
    transferType: "Tipo de Transferencia",
    domestic: "Nacional",
    international: "Internacional",
    exchangeRate: "Tasa de Cambio",
    fee: "Comisión",
    totalAmount: "Monto Total",
    youSend: "Usted Envía",
    theyReceive: "Ellos Reciben",
    getQuote: "Obtener Cotización",
    confirmTransfer: "Confirmar Transferencia",
    transferStatus: "Estado de Transferencia",
    
    // Beneficiaries
    addBeneficiary: "Agregar Beneficiario",
    beneficiaryName: "Nombre del Beneficiario",
    bankName: "Nombre del Banco",
    accountNumber: "Número de Cuenta",
    routingNumber: "Número de Ruta",
    swiftCode: "Código SWIFT",
    country: "País",
    
    // Statements
    statementTitle: "Estados de Cuenta",
    dateRange: "Rango de Fechas",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    exportCsv: "Exportar CSV",
    exportPdf: "Exportar PDF",
    
    // Settings
    changePassword: "Cambiar Contraseña",
    currentPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    accountSettings: "Configuración de Cuenta",
    securitySettings: "Configuración de Seguridad",
    
    // Support
    createTicket: "Crear Ticket",
    subject: "Asunto",
    message: "Mensaje",
    category: "Categoría",
    ticketStatus: "Estado del Ticket",
    open: "Abierto",
    inProgress: "En Progreso",
    resolved: "Resuelto",
    closed: "Cerrado",
    
    // Admin
    adminDashboard: "Panel de Administración",
    users: "Usuarios",
    kycCases: "Casos KYC",
    limitsAndFees: "Límites y Tarifas",
    riskRules: "Reglas de Riesgo",
    auditLogs: "Registros de Auditoría",
    supportTickets: "Tickets de Soporte",
    overview: "Resumen",
    totalUsers: "Total de Usuarios",
    pendingKyc: "KYC Pendiente",
    totalTransfers: "Total de Transferencias",
    pendingTransfers: "Transferencias Pendientes",
    approve: "Aprobar",
    reject: "Rechazar",
    requestMoreInfo: "Solicitar Más Información",
    approveException: "Aprobar Excepción",
    
    // Disclaimer
    disclaimer: "Youse Capital es un banco digital totalmente licenciado. Sus depósitos están protegidos y asegurados.",
    
    // Errors
    invalidCredentials: "Correo o contraseña inválidos",
    emailRequired: "El correo es requerido",
    passwordRequired: "La contraseña es requerida",
    insufficientFunds: "Fondos insuficientes",
    kycRequired: "Se requiere aprobación KYC",
    transferFailed: "Transferencia fallida",
    
    // Success
    loginSuccess: "Inicio de sesión exitoso",
    registrationSuccess: "Cuenta creada exitosamente",
    transferConfirmed: "Transferencia confirmada",
    beneficiaryAdded: "Beneficiario agregado",
    profileUpdated: "Perfil actualizado",
    passwordChanged: "Contraseña cambiada",
  }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];
